import PropTypes from 'prop-types';
import React from 'react';
import GeckoFeatures from 'services/gecko-features';
import { GeckoBtn, OverlayTrigger, Tooltip } from 'ui';

const ChannelSelectIncludeForm = (props) => {
  const { isFormResponse, onIncludeFormResponse } = props;

  const isHidden = !(
    isFormResponse && GeckoFeatures.can('include-form-response')
  );

  return (
    <div
      className="ChannelSelector__includeForm"
      hidden={isHidden}
      id="formInclude"
    >
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="formIncluded-tip">
            Include the form data within the email response
          </Tooltip>
        }
      >
        <div>
          <GeckoBtn
            id="formIncluded-tip"
            type="outline-primary"
            size="sm"
            name="Include Form Response"
            handler={onIncludeFormResponse}
          />
        </div>
      </OverlayTrigger>
    </div>
  );
};

ChannelSelectIncludeForm.propTypes = {
  isFormResponse: PropTypes.bool,
  onIncludeFormResponse: PropTypes.func,
};

export default ChannelSelectIncludeForm;
